module.exports = __webpack_public_path__ + "img/pow-design.7d6ecd6.jpeg";